var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533.3333333333333,
    height: 533.3333333333333,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(46.02833938598633 274.13021850585926,262.1309204101563) ",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#bf0000",
    strokeWidth: 37.1167,
    id: "path566",
    d: "m495.303802,262.130676c0,-125.226013 -99.022797,-226.741783 -221.173615,-226.741783c-122.150818,0 -221.173615,101.51577 -221.173615,226.741783c0.000046,125.226379 99.022888,226.742371 221.173737,226.74231c122.150818,-0.000031 221.173615,-101.516113 221.173553,-226.742493l-221.173676,0.000183l221.173615,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "none",
    strokeWidth: "1pt",
    id: "path575",
    d: "m445.611237,251.240189c0.032166,-115.39444 -93.835022,-208.957085 -209.637177,-208.957085c-115.80217,0 -209.669373,93.562645 -209.637207,208.957085c-0.000092,115.372086 93.857574,208.899734 209.636963,208.899857c115.779388,0.000092 209.637238,-93.527405 209.63736,-208.899475l-209.637115,-0.000381l209.637177,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    fillOpacity: 0.577778,
    id: "path564",
    d: "m117.569962,339.138519c0,-1.817993 -11.812996,-66.340973 0,-91.786972c21.811005,-39.078003 31.807007,-74.518997 33.625,-104.51001c0.908997,0.908997 1.818008,48.165009 -1.817993,53.618011c-10.904999,20.901993 -21.810005,44.530991 -29.080002,67.249985c0,44.529999 -1.818001,79.063995 -2.727005,75.428986z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#bf0000",
    strokeWidth: 37.5,
    id: "path567",
    d: "m112.200783,91.059654l292.310997,307.074501"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/none.57b708242199094b77bae0ecf4d08f97.svg";
export { ForwardRef as ReactComponent };